
import React, { useEffect, useRef } from 'react';
import { useTimer } from '@/hooks/useTimer';

interface TimerProps {
  onTimeUp?: () => void;
  onTimeUpdate?: (time: number) => void;
  staticTime?: number;
  disabled?: boolean;
}

export function Timer({
  onTimeUp,
  onTimeUpdate,
  staticTime,
  disabled
}: TimerProps) {
  const timerMounted = useRef(false);
  const {
    time,
    start,
    stop,
    isRunning
  } = useTimer(elapsedTime => {
    if (onTimeUpdate) {
      onTimeUpdate(elapsedTime);
    }
    if (time === 0 && onTimeUp) {
      onTimeUp();
    }
  });

  useEffect(() => {
    // Only start the timer once when the component mounts
    if (!disabled && !isRunning && staticTime === undefined && !timerMounted.current) {
      timerMounted.current = true;
      start();
    }
    
    return () => {
      if (isRunning) {
        stop();
      }
    };
  }, [disabled, isRunning, start, stop, staticTime]);

  // No visual output needed for the timer component
  return <div className="w-full"></div>;
}
